module.exports = __webpack_public_path__ + "media/ding.e00f0f3a.mp3";